import React from "react";
import Config from "./env/config";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/styles/global.css";
const App = () => {
  return (
    <>
      <Config />
    </>
  );
};

export default App;
